import PropTypes from 'prop-types';
import React from 'react';

import { Label, FormCard } from 'twyne-new.ui'

import Switch from 'components/form/Switch';
import Rules from 'components/rules/Rules';

export default function PageRulesTab({ disabled, data, handleChange, onConflict }) {
  return (
    <>
      <FormCard render={!!data} title='Rules' headerButtons={<div className='flex items-center gap-2'>
        <Switch name="override"
          disabled={disabled}
          setValue={active => {
            if (active) {
              handleChange({
                rules: {
                  condition: 'and',
                  groups: [],
                },
              })
            } else {
              handleChange({ rules: null })
            }
          }}
          value={!!data} />
        <Label>Active</Label>
      </div>}>
        <Rules
          rules={data || {
            condition: null,
            groups: [],
          }}
          handleChange={handleChange}
          disabled={!data || disabled}
          origin='page'
          onConflict={onConflict}
        />
      </FormCard>
    </>
  );
}

PageRulesTab.propTypes = {
  show: PropTypes.bool,
  data: PropTypes.any,
  handleChange: PropTypes.func,
};
